import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const painPoints = ['Perdés fines de semana buscando planos y el lunes empezás de cero', 'Tirás placas a la basura por errores de cálculo', 'Mandás presupuestos y el cliente desaparece', 'No podés justificar precios premium sin un sistema profesional', 'Mecanismos que fallan a los 3 meses por herrajes incorrectos'];
export function PainPoints() {
  return <section className="py-12 md:py-16 bg-white" data-id="element-151">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-152">
        <motion.h2 initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-3xl font-bold text-wood-dark mb-8 text-center" data-id="element-153">
          ¿Te suena familiar?
        </motion.h2>

        <div className="space-y-3 mb-10" data-id="element-154">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.08
        }} className="flex items-start p-3 rounded-lg" data-id="element-155">
              <XCircle className="w-5 h-5 text-red-500/80 mt-0.5 mr-3 flex-shrink-0" data-id="element-156" />
              <p className="text-base text-charcoal/80" data-id="element-157">{point}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-wood-dark text-cream p-6 md:p-8 rounded-2xl text-center shadow-warm wood-texture" data-id="element-158">
          <h3 className="text-xl md:text-3xl font-serif font-bold text-amber-light" data-id="element-159">
            ¿Cuántos tableros más vas a tirar haciendo lo mismo?
          </h3>
        </motion.div>
      </div>
    </section>;
}